import { Stack } from '@mui/material';
import LmTextField from '../../../../components/common/LmTextField';
import VegaFormInputField from '../../../../components/common/VegaFormInputField';
import {
  getConfigurationState,
  setConfigurations,
} from '../../../../features/configurationSlice';
import { useAppDispatch, useAppSelector } from '../../../../store';
import {
  ConfigValueProps,
  ConfigurationDto,
} from '../../../../types/configurationType';

export enum ACRFilterType {
  FIELD_ALLOCATIONS = 'FIELD_ALLOCATIONS',
  TELE_ALLOCATIONS = 'TELE_ALLOCATIONS',
}

const ACRForm = () => {
  const { configurations } = useAppSelector(getConfigurationState);
  const dispatch = useAppDispatch();

  const handleConfigChange = (key: keyof ConfigurationDto, value: any) => {
    const updateConfig = { ...configurations, [key]: value };
    dispatch(setConfigurations(updateConfig));
  };

  const handleLeaveRequestChange = (
    key: keyof ConfigValueProps,
    value: number | string
  ) => {
    const updateConfigValueObj = { ...configurations.config, [key]: value };
    handleConfigChange('config', updateConfigValueObj);
  };

  return (
    <Stack gap={2}>
      <VegaFormInputField label={'Field Acr Limit'}>
        <LmTextField
          type="number"
          value={configurations?.config?.fieldAcrLimit ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('fieldAcrLimit', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Tele Acr Limit'}>
        <LmTextField
          type="number"
          value={configurations?.config?.teleAcrLimit ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleLeaveRequestChange('teleAcrLimit', value);
          }}
        />
      </VegaFormInputField>
    </Stack>
  );
};

export default ACRForm;
